import { Type } from 'class-transformer';

import { Session } from '@/core/models/session.model';
import { PurposeOfUseEnum } from '@/core/models/enums/user.enums';


export class User {
  @Type(() => Session)
  public session: Session;

  constructor(
    public first_name: string,
    public last_name: string,
    public purpose_of_use: PurposeOfUseEnum,
    public company: string,
    public phone: string,
    public email: string,
    public creation_date: string,
    public last_connected: string,
    session: Session,
) {
    this.session = session;
  }
}
